import MyRequests from '../../components/views/common/MyRequests'

export default function MyRequestsPage() {
	return <MyRequests />
}
